export class MaTariffService {
  tariff_service_id: number | null = null;
  service_id: number | null = null;
  name: string | null = null;
  status: string | null = null;
  columns: string[] = [];

  constructor(tariffService?: Partial<MaTariffService>) {
    if (tariffService) {
      this.tariff_service_id = tariffService.tariff_service_id ?? null;
      this.service_id = tariffService.service_id ?? null;
      this.name = tariffService.name ?? null;
      this.status = tariffService.status ?? null;
      this.columns = tariffService.columns ?? [];
    }
  }
}

export class MaSubService {
  sub_service_id: number | null = null;
  service_id: number | null = null;
  name: string | null = null;
  status: string | null = null;

  constructor(subService?: Partial<MaSubService>) {
    if (subService) {
      this.sub_service_id = subService.sub_service_id ?? null;
      this.service_id = subService.service_id ?? null;
      this.name = subService.name ?? null;
      this.status = subService.status ?? null;
    }
  }
}

export class MaPortService {
  service_id: number | null = null;
  code: string | null = null;
  name: string | null = null;
  status: string | null = null;
  sub_services: MaSubService[] = [];
  tariff_services: MaTariffService[] = [];
  purpose: string | null = null;

  constructor(portService?: Partial<MaPortService>) {
    if (portService) {
      this.service_id = portService.service_id ?? null;
      this.code = portService.code ?? null;
      this.name = portService.name ?? null;
      this.status = portService.status ?? null;
      this.sub_services = (portService.sub_services?.map(s => new MaSubService(s)) ?? []);
      this.tariff_services = (portService.tariff_services?.map(t => new MaTariffService(t)) ?? []);
      this.purpose = portService.purpose ?? null;

    }
  }
}

// Model for the tariff rule Sub Service
export class TariffSubService {
  name: string | null = null;
  unique_key: string | null = null;
  basic_value: string | null = null;
  movement: string | null = null;
  tariff_percent: string | null = null;
  calculated_basic_value: number | null = null;
  formula_result: string | null = null;
  formula_inputs: string | null = null;
  optional: string | null = null;
  operational_flag: string | null = null;
  hide: string | null = null;
  sub_total: number | null = null;

  constructor(data?: Partial<TariffSubService>) {
    if (data) {
      this.name = data.name ?? null;
      this.unique_key = data.unique_key ?? null;
      this.basic_value = data.basic_value ?? null;
      this.movement = data.movement ?? null;
      this.tariff_percent = data.tariff_percent ?? null;
      this.calculated_basic_value = data.calculated_basic_value ?? null;
      this.formula_result = data.formula_result ?? null;
      this.formula_inputs = data.formula_inputs ?? null;
      this.optional = data.optional ?? null;
      this.hide = data.hide ?? null;
      this.operational_flag = data.operational_flag ?? null;
      this.sub_total = data.sub_total ?? null;
    }
  }
}

export class TariffService {
  SNO: number | null = null;
  code: string | null = null;
  total: string | null = null;
  service: string | null = null;
  purpose: string | null = null;
  pa_remark: string | null = null;
  meraki_feedback: string | null = null;
  meraki_remark_client: string | null = null;
  client_comment: string | null = null;
  info_msg: string | null = null;
  negotiate: string | null = null;
  agreed: string | null = null;
  client_option: string | null = null;
  display_to_client: string | null = null;
  subService: TariffSubService[] = [];

  constructor(data?: Partial<TariffService>) {
    if (data) {
      this.SNO = data.SNO ?? null;
      this.code = data.code ?? null;
      this.total = data.total ?? null;
      this.service = data.service ?? null;
      this.purpose = data.purpose ?? null;
      this.pa_remark = data.pa_remark ?? null;
      this.meraki_feedback = data.meraki_feedback ?? null;
      this.meraki_remark_client = data.meraki_remark_client ?? null;
      this.client_comment = data.client_comment ?? null;
      this.info_msg = data.info_msg ?? null;
      this.negotiate = data.negotiate ?? null;
      this.agreed = data.agreed ?? null;
      this.client_option = data.client_option ?? null;
      this.display_to_client = data.display_to_client ?? null;
      this.subService = (data.subService?.map(s => new TariffSubService(s)) ?? []);
    }
  }
}

export class TariffRequest {
  items: TariffService[] = [];
  grand_total: number = 0;

  constructor(data?: Partial<TariffRequest>) {
    if (data) {
      this.items = data.items?.map(i => new TariffService(i)) ?? [];
      this.grand_total = data.grand_total ?? 0;
    }
  }
}